import { Backdrop, CircularProgress } from "@mui/material";
import React from "react";

export default function LoadingComponent({ loading }: { loading: boolean }) {
	return (
		<Backdrop
			sx={{ color: "#fff", zIndex: 9999 }}
			open={loading}
			invisible={false}
		>
			<CircularProgress size={70} color="primary" />
		</Backdrop>
	);
}
